var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.36218 2.43143H25.6323C26.3388 2.43143 26.8574 1.99564 26.8574 1.28531C26.8574 0.574982 26.2851 0 25.5786 0H1.42257C0.716076 0 0.143784 0.574982 0.143784 1.28531C0.143784 1.99564 0.655682 2.43143 1.36218 2.43143ZM25.6326 7.29135H1.36248C0.655983 7.29135 0.148876 7.79626 0.148876 8.50659C0.148876 9.21692 0.655983 9.72087 1.36248 9.72087H25.6326C26.3391 9.72087 26.8462 9.21692 26.8462 8.50659C26.8462 7.79626 26.3391 7.29135 25.6326 7.29135ZM18.3507 14.581H1.36221C0.655716 14.581 0.143818 15.0044 0.143818 15.7147C0.143818 16.425 0.716108 17 1.42261 17H18.4811C19.1876 17 19.7599 16.425 19.7599 15.7147C19.7599 15.0044 19.0572 14.581 18.3507 14.581Z","fill":"#202239"}));
}

Menu.defaultProps = {"width":"27","height":"17","viewBox":"0 0 27 17","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
